import baseUrl from "../config/baseUrl";

const approveRequestedCase = async ({
  token,
  doc_id,
  doc_req_id,
}) => {
  try {
    let url = `${baseUrl}/api/update-document-request-data?document_status=approved&document_id=${doc_id}&document_request_id=${doc_req_id}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default approveRequestedCase;